/**
 * 🎨 ADD ELEMENT MENU 2025
 * 
 * Wiederverwendbare Komponente für das Add-Element-Menu
 * - Schönes blaues Gradient-Design (wie Empty State)
 * - Kann überall verwendet werden
 * - Portal-Rendering für perfektes Positioning
 * - Inkludiert Grid Presets
 */

import React from 'react';
import { gridPresets } from './gridPresets';
import './AddElementMenu.css';

function AddElementMenu({ onAdd, onClose, colors = {} }) {
    const handleAddElement = (type, elementType = 'custom') => {
        onAdd(type, elementType);
        if (onClose) onClose();
    };
    
    // ✅ Grid Preset Handler
    const handleAddGridPreset = (presetId) => {
        // Trigger onAdd with grid preset type
        onAdd('gridPreset', presetId);
        if (onClose) onClose();
    };

    return (
        <div className="add-element-menu-2025" onClick={(e) => e.stopPropagation()}>
            {/* Menu Header */}
            <div className="add-element-menu-2025-header">
                <h4>Add Element</h4>
                <button 
                    className="add-element-menu-2025-close"
                    onClick={(e) => {
                        e.stopPropagation();
                        if (onClose) onClose();
                    }}
                >
                    <i className="fas fa-times"></i>
                </button>
            </div>
            
            {/* Text-Typen */}
            <button 
                className="add-element-menu-2025-item"
                onClick={() => handleAddElement('text', 'h1')}
            >
                <span className="add-element-menu-2025-badge">H1</span>
                <span>Large Heading</span>
            </button>
            <button 
                className="add-element-menu-2025-item"
                onClick={() => handleAddElement('text', 'h2')}
            >
                <span className="add-element-menu-2025-badge">H2</span>
                <span>Medium Heading</span>
            </button>
            <button 
                className="add-element-menu-2025-item"
                onClick={() => handleAddElement('text', 'h3')}
            >
                <span className="add-element-menu-2025-badge">H3</span>
                <span>Small Heading</span>
            </button>
            <button 
                className="add-element-menu-2025-item"
                onClick={() => handleAddElement('text', 'p')}
            >
                <i className="fas fa-align-left"></i>
                <span>Paragraph</span>
            </button>
            
            {/* Divider */}
            <div className="add-element-menu-2025-divider"></div>
            
            {/* Button */}
            <button 
                className="add-element-menu-2025-item"
                onClick={() => handleAddElement('button')}
            >
                <i className="fas fa-hand-pointer"></i>
                <span>Button</span>
            </button>
            
            {/* Image */}
            <button 
                className="add-element-menu-2025-item"
                onClick={() => handleAddElement('image')}
            >
                <i className="fas fa-image"></i>
                <span>Image</span>
            </button>
            
            {/* Video */}
            <button 
                className="add-element-menu-2025-item"
                onClick={() => handleAddElement('video')}
            >
                <i className="fas fa-play-circle"></i>
                <span>Video</span>
            </button>
            
            {/* Gallery */}
            <button 
                className="add-element-menu-2025-item"
                onClick={() => handleAddElement('gallery')}
            >
                <i className="fas fa-images"></i>
                <span>Gallery</span>
            </button>
            
            {/* Q&A */}
            <button 
                className="add-element-menu-2025-item"
                onClick={() => handleAddElement('qa')}
            >
                <i className="fas fa-comments"></i>
                <span>Q&A Section</span>
            </button>
            
            {/* Divider Element */}
            <button 
                className="add-element-menu-2025-item"
                onClick={() => handleAddElement('divider')}
            >
                <i className="fas fa-grip-lines"></i>
                <span>Divider</span>
            </button>
            
            {/* Countdown Bar Element */}
            <button 
                className="add-element-menu-2025-item"
                onClick={() => handleAddElement('countdownBar')}
            >
                <i className="fas fa-hourglass-half"></i>
                <span>Countdown Bar</span>
            </button>
            
            {/* Footer Element */}
            <button 
                className="add-element-menu-2025-item"
                onClick={() => handleAddElement('footer')}
            >
                <i className="fas fa-shoe-prints"></i>
                <span>Footer</span>
            </button>
            
            {/* Layouts Section */}
            <div className="add-element-menu-2025-divider"></div>
            <div className="add-element-menu-2025-label">
                <i className="fas fa-layer-group" style={{ marginRight: '6px', fontSize: '9px', opacity: 0.8 }}></i>
                Layouts
            </div>
            
            {/* Grid Layouts */}
            <button 
                className="add-element-menu-2025-item"
                onClick={() => handleAddElement('grid', '2-columns')}
            >
                <i className="fas fa-columns"></i>
                <span>2 Columns</span>
            </button>
            <button 
                className="add-element-menu-2025-item"
                onClick={() => handleAddElement('grid', '3-columns')}
            >
                <i className="fas fa-th"></i>
                <span>3 Columns</span>
            </button>
            
            {/* ✨ Grid Presets Section */}
            <div className="add-element-menu-2025-divider"></div>
            <div className="add-element-menu-2025-label">
                <i className="fas fa-sparkles" style={{ marginRight: '6px', fontSize: '9px', opacity: 0.8 }}></i>
                Templates
            </div>
            
            {Object.entries(gridPresets).map(([presetId, preset]) => (
                <button 
                    key={presetId}
                    className="add-element-menu-2025-item add-element-menu-2025-preset"
                    onClick={() => handleAddGridPreset(presetId)}
                    title={preset.description}
                >
                    <div className="add-element-menu-2025-preset-icon">
                        <i className={`fas ${preset.icon || 'fa-th'}`}></i>
                    </div>
                    <div className="add-element-menu-2025-preset-info">
                        <span className="add-element-menu-2025-preset-title">{preset.name}</span>
                        <span className="add-element-menu-2025-preset-desc">{preset.description}</span>
                    </div>
                </button>
            ))}
        </div>
    );
}

export default AddElementMenu;

